import React, { useState } from "react";

import "./LiveCasinoSearch.scss";

interface ILiveCasinoSearch {
  seacrhGames: string;
  setSeacrhGames: React.Dispatch<React.SetStateAction<string>>;
}

const LiveCasinoSearch = ({
  setSeacrhGames,
  seacrhGames,
}: ILiveCasinoSearch) => {
  const [inputOpen, setInputOpen] = useState(false);
  const handleOpenInput = () => {
    setInputOpen((prev) => !prev);
    setSeacrhGames("");
  };
  const handeSearchGames = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSeacrhGames(e.target.value);
  };
  return (
    <div className="live-casino-search casino-title-search">
      <div className={`sport-search-bc ${inputOpen ? "active" : ""} `}>
        {inputOpen ? (
          <input
            type="text"
            className="ss-input-bc"
            placeholder="Search casino game"
            defaultValue=""
            onChange={handeSearchGames}
            value={seacrhGames}
          />
        ) : null}

        <div className="ss-icon-holder-bc" onClick={handleOpenInput}>
          <i
            className={`ss-icon-bc bc-i-${
              inputOpen ? "close-remove" : "search"
            } `}
          />
        </div>
      </div>
    </div>
  );
};

export { LiveCasinoSearch };
